export default {
  createAgreementTerm: 'api/mssign/create-agreement-term',
  signAgreementTerm: 'api/mssign/sign-agreement-term',
  signTermUrl: 'api/mssign/sign-term-url'
};
